import React, { useEffect, useState } from 'react';
import { isAutoLoadEnabled, setAutoLoadEnabled } from '@paxsudos/upload-by-url/auto_load_prefs';

export default function AutoLoadImagesSetting() {
  const [on, setOn] = useState(isAutoLoadEnabled());

  useEffect(() => setOn(isAutoLoadEnabled()), []);

  return (
    <div className="fields-group">
      <div className="field checkbox">
        <label>
          <input
            type="checkbox"
            checked={on}
            onChange={(e) => { setOn(e.target.checked); setAutoLoadEnabled(e.target.checked); }}
          />
          <strong style={{ marginLeft: 8 }}>Automaattinen median upotus</strong>
        </label>
        <p className="hint">
          Jos päällä, niin linkitetyt mediat haetaan ja upotetaan viestiin.
        </p>
      </div>
    </div>
  );
}

